import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from '../../types/entity';

export interface IPdf extends IEntity {
  attributes: {
    id: EntityStringId;
    url: string;
  };
}

export type Pdf = Entity<IPdf>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Pdf: IEntityType<IPdf> = vmClient.defineClass({
  typeName: 'Pdf',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    url: {
      notNull: true,
      type: 'string',
    },
  },
});
